import {configParamsModule} from "../../configParamsModule"
import {
    LoadingService,
    MessagesModal,
    RemoteExceptionHandler
} from "../../../../bower_components/front-end-web-commons";
import {PermissionGroupSupportService} from "../support/permissionGroupSupportService";

export interface ExternalFreightModel {
    id: number | null,
    apiUrl: string,
    apiUser: string,
    apiPassword: string,
    isAllowed: boolean
}

class NlgExternalFreightConfiguration {
    model: ExternalFreightModel = {
        id: null,
        apiUrl: "",
        apiUser: "",
        apiPassword: "",
        isAllowed: false
    }

    constructor(private loadingService: LoadingService,
                private remoteExceptionHandler: RemoteExceptionHandler,
                private messagesModal: MessagesModal,
                private permissionGroupSupportService: PermissionGroupSupportService,
                private $state: any) {
        this.loadingService(this.permissionGroupSupportService.getExternalFreightConfigurations())
            .catch(this.remoteExceptionHandler())
            .then((configurations: any) => {
                this.model = configurations;
            });

    }

    saveExternalFreightConfigurations() {
        return this.loadingService(this.permissionGroupSupportService.saveExternalFreightConfigurations(this.model))
            .catch(this.remoteExceptionHandler())
            .then(() => this.messagesModal("dialog.success", ["external.freight.configurations.saved"]).then(() => this.$state.reload()));
    }

}

export const directive = configParamsModule.directive("nlgExternalFreightConfiguration", [function () {
    return {
        restrict: "E",
        templateUrl: require("link!./nlgExternalFreightConfiguration.html"),
        scope: {},
        controllerAs: "ctrl",
        controller: NlgExternalFreightConfiguration
    }
}])